import React from "react";
import PropTypes from "prop-types";
import { Tabs } from "antd";

// eslint-disable-next-line import/no-cycle
import UsageInSetsTable from "../../shared/components/UsageInSetsTable";

const ProductDetailsPanel = ({ t, productId }) => (
  <Tabs size="small" centered>
    <Tabs.TabPane tab={t("menu.Products.DetailsPanel.UsageTab.Title")} key="usage">
      <UsageInSetsTable productId={productId} />
    </Tabs.TabPane>
  </Tabs>
);

ProductDetailsPanel.propTypes = {
  productId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default ProductDetailsPanel;
